"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CheckfilledIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/CheckfilledIcon"));
var _CheckboxIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/CheckboxIcon"));
var _IndeterminatefilledIcon = _interopRequireDefault(require("@8x8/oxygen-icon/novo/IndeterminatefilledIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CheckboxIconNovo = function CheckboxIconNovo(_ref) {
  var color = _ref.color,
    isChecked = _ref.isChecked,
    isIndeterminate = _ref.isIndeterminate;
  switch (true) {
    case isChecked:
      {
        return /*#__PURE__*/_react["default"].createElement(_CheckfilledIcon["default"], {
          color: color
        });
      }
    case isIndeterminate:
      {
        return /*#__PURE__*/_react["default"].createElement(_IndeterminatefilledIcon["default"], {
          color: color
        });
      }
    default:
      {
        return /*#__PURE__*/_react["default"].createElement(_CheckboxIcon["default"], {
          color: color
        });
      }
  }
};
CheckboxIconNovo.propTypes = {
  color: _propTypes["default"].string.isRequired,
  isChecked: _propTypes["default"].bool.isRequired,
  isIndeterminate: _propTypes["default"].bool.isRequired
};
var _default = CheckboxIconNovo;
exports["default"] = _default;